
import { Circle } from 'lucide-react';
import OrderCard from './OrderCard';
import { Order } from '../OrderHistory';

interface OrderListProps {
  orders: Order[];
  isMobile: boolean;
  onViewDetails: (orderId: string) => void;
  onReorder: (orderId: string) => void;
  reorderingId: string | null;
}

const OrderList = ({ orders, isMobile, onViewDetails, onReorder, reorderingId }: OrderListProps) => {
  return (
    <div className="relative space-y-4 mt-6">
      {!isMobile && <div className="absolute left-[11px] h-full w-0.5 bg-border/50" />}
      
      {orders.map((order) => (
        <div key={order.id} className="relative flex items-start">
          {!isMobile && (
            <div className="flex h-full w-6 items-center justify-center">
              <div className="absolute top-1 -left-[0.5px] z-10">
                <div className="h-6 w-6 rounded-full bg-background flex items-center justify-center">
                  <Circle className="h-3 w-3 text-primary" fill="currentColor" />
                </div>
              </div>
            </div>
          )}
          <OrderCard 
            order={order} 
            onViewDetails={onViewDetails} 
            onReorder={onReorder}
            isReordering={reorderingId === order.id}
            isMobile={isMobile}
          />
        </div>
      ))}
    </div>
  );
};

export default OrderList;
